import { component as defineComponent } from 'flightjs';
import $ from 'jquery';

function ScrollToElement() {
    this.defaultAttrs({
        buttonSelector: '[data-scroll-to-element-button]',
        targetSelector: '[data-scroll-to-element-target]',
    });

    this.after('initialize', function () {
        this.on('click', {
            buttonSelector: this.scroll,
        });
    });

    this.scroll = function () {
        const targetOffset = this.select('targetSelector').offset().top;
        $('html, body').animate({
            scrollTop: targetOffset,
        }, 350);
    };
}

export default defineComponent(ScrollToElement);



// WEBPACK FOOTER //
// ./src/js/component_ui/scroll-to-element.js